import { useState, useCallback } from "react";

export function useFormHandler(initialState = {}) {
  const [formData, setFormData] = useState(initialState);

  const handleChange = useCallback(
    (field, options = {}) => (event, value) => {
      const { type = "text", transform } = options;

      setFormData((prev) => {
        let newValue;

        switch (type) {
          case "checkbox":
            newValue = event.target.checked;
            break;

          case "autocomplete":
            newValue = transform ? transform(value) : value;
            break;

          case "select":
          case "date":
          default:
            newValue = transform
              ? transform(event.target.value)
              : event.target.value;
            break;
        }

        return {
          ...prev,
          [field]: newValue,
        };
      });
    },
    []
  );

  const setField = useCallback((field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  return {
    formData,
    handleChange,
    setField,
  };
}
